
import { CollisionEvent, SimulationConfig } from '@/types';
import { lerpColor } from './BreakUtils';
import { COLLISION_ANIMATIONS } from '@/logic/animations/collisions/CollisionAnimationRegistry';

export const drawCollisionEffect = (
    ctx: CanvasRenderingContext2D,
    e: CollisionEvent,
    config: SimulationConfig,
    globalHue: number,
    canvasWidth?: number,
    canvasHeight?: number,
    camera?: { x: number, y: number, scale: number }
) => {
    const elapsed = Date.now() - e.startTime;
    const duration = config.collisionEffectDuration || 800;
    if (elapsed > duration) return;
    
    const progress = elapsed / duration;
    const type = e.effectType || 'RIPPLE';
    
    ctx.save();
    
    const determineColor = (idx: number, total: number) => {
        const mode = config.collisionEffectColorMode;
        const useRGB = config.rgbLighting && config.useFXRGB;
        
        let baseColor = e.color;
        if (!config.rgbLighting && baseColor.startsWith('hsl')) {
            baseColor = config.blastColor || '#ffffff';
        }

        if (mode === 'BALL_COLOR') {
            if (config.useBallRGB) {
                return `hsl(${(globalHue + idx * 10) % 360}, 100%, 60%)`;
            }
            return baseColor;
        }

        if (useRGB || mode === 'RAINBOW') {
            return `hsl(${(globalHue + idx * 10) % 360}, 100%, 60%)`;
        }
        if (mode === 'CUSTOM_SOLID') return config.collisionEffectColor1;
        if (mode === 'CUSTOM_GRADIENT') return lerpColor(config.collisionEffectColor1, config.collisionEffectColor2, idx/total);
        return baseColor; 
    };

    const animationFn = COLLISION_ANIMATIONS[type];
    if (animationFn) {
        animationFn(ctx, e, config, progress, elapsed, globalHue, determineColor);
    }
    
    ctx.restore();
};
